import SpellsFilterAdvancedFilter from "./SpellsFilterAdvancedFilter";

export default SpellsFilterAdvancedFilter;
export { SpellsFilterAdvancedFilter };
